import { ReactNode, useEffect, useState } from 'react';
import i18n, { FlatNamespace, ParseKeys } from 'i18next';
import { LocaleKey } from '@models/Locales';

interface Props<Ns extends FlatNamespace> {
    ns: Ns;
    i18nKey: ParseKeys<Ns>;
    interval?: number;
    languages?: string[];
    children?: (text: string) => ReactNode;
}

const RotatingTranslation = <Ns extends FlatNamespace>({ ns, i18nKey, interval = 4000, languages }: Props<Ns>) => {
    const [index, setIndex] = useState(0);
    const [langs, setLangs] = useState<string[]>(languages || []);

    useEffect(() => {
        const availableLangs = Object.values(LocaleKey);
        setLangs(availableLangs);

        i18n.loadLanguages(availableLangs);

        const timer = setInterval(() => {
            setIndex((i) => (i + 1) % availableLangs.length);
        }, interval);

        return () => clearInterval(timer);
    }, [languages, interval]);

    if (!langs.length) return null;

    const text = i18n.t(String(i18nKey), '', { lng: langs[index], ns });

    return <>{text}</>;
};

export default RotatingTranslation;
